import React, { useMemo } from "react";
import "./EcommerceServiceLevels.scss";
import { FormattedMessage } from "react-intl";
import moment from "moment";
import * as _ from "lodash-es";
import IServiceLevel from "@models/IServiceLevel";
import { getServiceLevelShipDate } from "@utils/serviceLevelShipDate";

type Props = {
    serviceLevels: IServiceLevel[];
};

export const EcommerceServiceLevels: React.FC<Props> = ({ serviceLevels }) => {
    // Compute "today" once so every entry shares the same reference date.
    const today = useMemo(() => moment(), []);

    // Default level first, then fastest lead time first (mirrors the sort in ServiceLevelsSidebar).
    const ordered = useMemo(
        () => _.orderBy(serviceLevels, [(level) => (level.is_default ? 0 : 1), "lead_time"], ["asc", "asc"]),
        [serviceLevels]
    );

    if (!ordered.length) {
        return null;
    }

    return (
        <div className="EcommerceServiceLevels mb-4">
            <div className="service-level-chip">
                {ordered.map((level, index) => (
                    <React.Fragment key={level.guid ?? level.id ?? level.name}>
                        {index > 0 ? <span className="service-level-bullet">&bull;</span> : null}
                        <span className={"service-level-item" + (level.is_default ? " is-default" : "")}>
                            {level.is_expedited ? <i className="fas fa-rabbit-fast me-2" /> : null}
                            <span className="service-level-name">{level.name}</span>
                            <span className="service-level-ship-date">
                                <FormattedMessage id="ships_by" /> {getServiceLevelShipDate(level, today).format("ddd, MMM D")}
                            </span>
                        </span>
                    </React.Fragment>
                ))}
            </div>
        </div>
    );
};
